// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__Y0XI6","container":"Modal_container__0Dxgb"};